import Vue from 'vue'
import VueRouter from 'vue-router'

import Contact from '@/pages/contact/contact'
import Home from '@/pages/home/home'
import BlogPage from '@/pages/blog-page/blog-page'
import Blog from '@/pages/blog/blog'
import MeetUs from '@/pages/meet-us/meet-us'
import Services from '@/pages/services/services'
import Technology from '@/pages/technology/technology'
import ThankYou from '@/pages/thank-you/thank-you'
import WhyChooseUs from '@/pages/why-choose-us/why-choose-us'
import GetStarted from '@/pages/get-started/get-started'
import Accessibility from '@/pages/accessibility/accessibility'
import scrollBehavior from '@/shared/functionality/scroll-behavior'
import OnlineConsultation from '@/pages/online-consultation/online-consultation'
import ForFun from '@/pages/for-fun/for-fun'
import Resources from '@/pages/resources/resources'
import Sitemap from '@/pages/sitemap/sitemap'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      linkName: 'HOME',
      navigation: true,
      mobile: true,
      component: Home
    },
    {
      path: '/about-us',
      name: 'About Us',
      navigation: true,
      mobile: true,
      component: MeetUs,
      children: [
        {
          name: 'Meet Dr. Lovrovich',
          path: '/about-us#dr-lovrovich'
        },
        {
          name: 'Meet The Team',
          path: '/about-us#about-staff'
        }
      ]
    },
    {
      path: '/patients',
      name: 'Patients',
      navigation: true,
      mobile: true,
      component: WhyChooseUs,
      children: [
        {
          name: 'Appointments',
          path: '/patients#appointments',
          id: 'appointments'
        },
        {
          name: 'Insurance',
          path: '/patients#insurance',
          id: 'insurance'
        },
        {
          name: 'Financial Policy',
          path: '/patients#financial',
          id: 'financial'
        },
        {
          name: 'Consultations',
          path: '/patients#consultations',
          id: 'consultations'
        },
        {
          name: 'Patient Forms',
          path: '/patients#forms',
          id: 'forms'
        }
      ]
    },
    {
      path: '/services',
      name: 'Services',
      navigation: true,
      mobile: true,
      component: Services,
      children: [
        {
          name: 'Early Orthodontics',
          path: '/services#services'
        },
        {
          name: 'Adult Orthodontics',
          path: '/services#services'
        },
        {
          name: 'General Orthodontics',
          path: '/services#services'
        }
      ]
    },
    {
      path: '/technology',
      name: 'Technology',
      navigation: true,
      mobile: true,
      component: Technology,
      children: [
        {
          name: 'Acceledent®',
          path: '/technology#technology'
        },
        {
          name: 'Insigna®',
          path: '/technology#technology'
        },
        {
          name: 'Invisalign®',
          path: '/technology#technology'
        },
        {
          name: 'PROPEL®',
          path: '/technology#technology'
        },
        {
          name: 'itero-Scanner®',
          path: '/technology#technology'
        },
        {
          name: 'Plaque HD™',
          path: '/technology#technology'
        },
        {
          name: 'OrthoPulse®',
          path: '/technology#technology'
        },
        {
          name: 'Carriere® Motion™',
          path: '/technology#technology'
        }
      ]
    },
    {
      path: '/contact',
      name: 'Contact',
      navigation: true,
      mobile: true,
      component: Contact
    },
    {
      path: '/blog',
      name: 'blog',
      navigation: false,
      component: Blog
    },
    {
      path: '/blog/:blog',
      name: 'blog page',
      navigation: false,
      mobile: false,
      component: BlogPage
    },
    {
      path: '/thank-you',
      name: 'thank you',
      navigation: false,
      mobile: false,
      component: ThankYou
    },
    {
      path: '/accessibility',
      name: 'Accessibility',
      navigation: false,
      mobile: false,
      component: Accessibility
    },
    {
      path: '/get-started',
      name: 'Get Started',
      navigation: false,
      mobile: false,
      component: GetStarted
    },
    {
      path: '/online-consult',
      name: 'Online Consultation',
      navigation: false,
      mobile: false,
      component: OnlineConsultation
    },
    {
      path: '/for-fun',
      name: 'For Fun',
      navigation: false,
      mobile: false,
      component: ForFun
    },
    {
      path: '/resources',
      name: 'Resources',
      navigation: false,
      mobile: false,
      component: Resources
    },
    {
      path: '/sitemap',
      name: 'Sitemap',
      navigation: false,
      mobile: false,
      component: Sitemap
    },
    {
      path: '/*',
      navigation: false,
      component: Home
    }
  ],
  scrollBehavior
})

router.beforeEach((to, from, next) => {
  if (from.path !== to.path) {
    window.scrollTo(0, 0)
  }
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js